module.exports = __webpack_public_path__ + "03552316c5666002267363883c4c0911.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/take_two_interactive_software_2022_chart.png
// module id = 1737
// module chunks = 0